import vueTickDebounce from 'vue-tick-debounce';

export default {
  created () {
    const debouncedDispatch = actionName =>
      vueTickDebounce(() => {
        this.$store.dispatch(actionName, undefined, { root: true });
      });
    const dispatchGameUpdate = debouncedDispatch('gameUpdated');
    const dispatchStationUpdate = debouncedDispatch('stationUpdated');
    this.__entitiesHooksUnsub = this.$store.subscribe(({ type, payload }) => {
      if (type === 'entitySet') {
        if (payload._type === 'Game') dispatchGameUpdate();
        if (payload._type === 'Station') dispatchStationUpdate();
      }
    });
  },
  beforeDestroy () {
    this.__entitiesHooksUnsub && this.__entitiesHooksUnsub();
  },
};
